/** Day and month of a birthday, without the year. */
export type BirthdayDate = { day: number; month: number }

/** Month names as the selects show them, January first. */
export const BIRTHDAY_MONTHS = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
] as const

/** Days a month can have in any year; February keeps the 29th for leap-day birthdays. */
export function daysInBirthdayMonth(month: number): number {
  if (month === 2) return 29
  return [4, 6, 9, 11].includes(month) ? 30 : 31
}

/** Reads the Dia and Mês select values as a valid calendar day and month (29/02 allowed), or null. */
export function parseBirthdayDate(day: string, month: string): BirthdayDate | null {
  const d = Number(day)
  const m = Number(month)
  if (!Number.isInteger(d) || !Number.isInteger(m) || m < 1 || m > 12 || d < 1) return null
  return d > daysInBirthdayMonth(m) ? null : { day: d, month: m }
}

/** Keeps the chosen day when it exists in the new month, otherwise clears it. */
export function clampBirthdayDay(day: string, month: string): string {
  if (!day || !month) return day
  return Number(day) > daysInBirthdayMonth(Number(month)) ? "" : day
}

/** "15 de março". */
export function formatBirthday({ day, month }: BirthdayDate): string {
  return `${day} de ${(BIRTHDAY_MONTHS[month - 1] ?? "").toLowerCase()}`
}
